module.exports = __webpack_public_path__ + "img/xrpintel.a3346a73.png";